<script setup>
import { ref, onMounted, reactive, defineProps } from "vue";
import { Graphics } from "pixi.js";
import { simplifyWhiteboard } from "./util";

const props = defineProps({
    data: {
        type: Object,
    },
});

const appRef = ref();
const containerRef = ref();
const state = reactive({
    players: [],
});

function initApp() {
    let interval = setInterval(function () {
        const appVal = appRef.value;
        const container = containerRef.value;
        console.log({ appVal, container });
        if (appVal && container) {
            clearInterval(interval);
            const app = appRef.value.app;
            console.log({ width: app.view.width, height: app.view.height });
            // container.pivot.set(app.view.width / 2, app.view.height / 2);
            container.position.set(app.view.width / 2, app.view.height / 2);
            // for (let i = 0; i < 20; i++) {
            // let circle = new Graphics().circle(10, 10, 20).fill("red");
            // container.addChild(circle)
            // }
        }
    }, 100);
}

async function getWhiteboard() {
    const resp = await axios.get(
        `http://127.0.0.1:8080/api/loadwhiteboard?wid=${props.data.room_code}`
    );
    state.players = simplifyWhiteboard(resp.data);
    console.log({ players: state.players });
}

onMounted(() => {
    initApp();
    getWhiteboard();
});
</script>

<template>
    <Application :width="1138" :height="640" ref="appRef" background="#ffffff">
        <sprite
            :texture="data.background"
            :alpha="0.2"
            width="1138"
            height="640"
        />
        <container ref="containerRef"> </container>
    </Application>
</template>
